import React from 'react';
import { OptionHistoryInterval } from '../types/StockData';

interface OptionHistoryIntervalSelectorProps {
  selectedInterval: OptionHistoryInterval;
  onIntervalChange: (interval: OptionHistoryInterval) => void;
}

export const OptionHistoryIntervalSelector: React.FC<OptionHistoryIntervalSelectorProps> = ({
  selectedInterval,
  onIntervalChange,
}) => {
  const intervals: { value: OptionHistoryInterval; label: string }[] = [
    { value: 5, label: '5 Days' },
    { value: 10, label: '10 Days' },
    { value: 30, label: '30 Days' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">
        Time Interval
      </h4>
      <div className="flex gap-2">
        {intervals.map(({ value, label }) => (
          <button
            key={value}
            onClick={() => onIntervalChange(value)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              selectedInterval === value
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};
